import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, message, Steps, Checkbox, Upload, Modal } from "antd";
import axios from "axios";
import { PlusOutlined } from "@ant-design/icons";
import { useDrawer } from "../../../context/drawer";

const { Option } = Select;
const { Step } = Steps;

const Product = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [productId, setProductId] = useState(null);
  const [ColorId, setColorId] = useState(null);
  const [form] = Form.useForm();
  const [colorForm] = Form.useForm();
  const [sizeForm] = Form.useForm();
  const [sizes, setSizes] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const { toggleDrawer } = useDrawer();
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://1fiveglobal.com/api/category.php?action=fetch&admin_token=OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH"
        );
        if (response.data.list) {
          setCategories(response.data.list || []);
        } else {
          message.error("Failed to fetch categories");
        }
      } catch (error) {
        message.error("Error fetching categories");
      }
    };

    fetchCategories();
  }, []);

  const handleProductNameChange = (e) => {
    const productName = e.target.value;
    const slug = productName.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
    form.setFieldsValue({ slug });
  };

  const handleProductSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("action", "add");
    formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
    formData.append("product_name", values.product_name);
    formData.append("product_desc", values.product_desc);
    formData.append("category_id", values.category_id);
    formData.append("product_type", values.product_type);
    formData.append("slug", values.slug);
    formData.append("material", values.Material);
    formData.append("care", values.care);
    formData.append("product_code", values.product_code);
    formData.append("Breadth", values.Breadth);
    formData.append("Height", values.Height);
    formData.append("Length", values.Length);
    formData.append("delivery_charges", "0");
    formData.append("out_stock", "0");

    try {
      const response = await axios.post(
        "https://1fiveglobal.com/api/product.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status <= 300) {
        message.success(response.data.status);
        setProductId(response.data.id);
        setCurrentStep(1);
      } else {
        message.error(response.data.status || "Failed to add product");
      }
    } catch (error) {
      console.log("error", error)
      message.error(error.response.data.status);

    }
    setLoading(false);
  };

  const handleColorSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("action", "addColor");
    formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
    formData.append("color_code", values.color_code);
    formData.append("color_name", values.color_name);
    formData.append("product_price", values.product_price);
    formData.append("product_qty", values.product_qty);
    formData.append("product_id", productId);

    try {
      const response = await axios.post(
        "https://1fiveglobal.com/api/product.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("response.data.color_id", response)
      if (response.status >= 200 && response.status <= 300) {
        message.success(response.data.status);
        setColorId(response.data.color_id);
        setCurrentStep(2);
      } else {
        message.error(response.data.status || "Failed to add color");
      }
    } catch (error) {
      message.error("Error submitting color", error);
    }
    setLoading(false);
  };
  const handleSizeSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("action", "addSized");
    formData.append("color_id", ColorId);
    // formData.append("color_id", "59");
    formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
    sizes.forEach((size, index) => {
      formData.append("product_size[]", size.product_size);
      formData.append("qty[]", size.product_size_quantity);
      formData.append("price[]", size.product_size_price);
      formData.append("out_of_stock[]", size.stock ? "1" : "0");
    });


    try {
      const response = await axios.post(
        "https://1fiveglobal.com/api/product.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status <= 300) {
        message.success(response.data.status);
        sizeForm.resetFields();
        setCurrentStep(3);
      } else {
        message.error(response.data.status || "Failed to add size");
      }
    } catch (error) {
      console.log("error", error)
      message.error("Error submitting size");
    }
    setLoading(false);
  };

  const addSizeField = () => {
    setSizes([...sizes, { product_size: "", product_size_quantity: "", product_size_price: "", stock: false }]);
  };

  console.log("sizes", sizes)

  const handleSizeChange = (index, field, value) => {
    const newSizes = [...sizes];
    newSizes[index][field] = value;
    setSizes(newSizes);
  };

  // image upload 

  // Image compression function
  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6, // Compression quality (adjust as needed)
        maxWidth: 1024, // Resize width (optional)
        maxHeight: 1024, // Resize height (optional)
        success(result) {
          if (result.size / 1024 < 300) {
            resolve(result);
          } else {
            reject(new Error("Image still too large after compression"));
          }
        },
        error(err) {
          reject(err);
        },
      });
    });
  };
  console.log("ColorId", ColorId)

  const handleImageUpload = async () => {
    // if (!ColorId || fileList.length === 0) {
    //   message.error("Please select a color and at least one image.");
    //   return;
    // }

    setLoading(true);

    const formData = new FormData();
    formData.append("action", "AddImages");
    // formData.append("color_id", "59");
    formData.append("color_id", ColorId);
    formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");

    fileList.forEach((file) => {
      if (file.originFileObj) {
        formData.append("images[]", file.originFileObj);
      }
    });

    try {
      const response = await axios.post("https://1fiveglobal.com/api/product.php", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status >= 200 && response.status <= 300) {
        message.success(response.data.status);
        toggleDrawer();
        setCurrentStep(0);
      } else {
        message.error(response.data.status || "Failed to upload images");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      message.error(error.response?.data?.message || "Error uploading images");
    } finally {
      setLoading(false);
    }
  };


  const handleChange = async ({ file, fileList }) => {
    if (file.status !== "done" && file.originFileObj) {
      try {
        const compressedFile = await compressImage(file.originFileObj);
        const newFile = new File([compressedFile], file.name, { type: file.type });
        const updatedFile = { ...file, originFileObj: newFile };
        setFileList([...fileList.slice(0, -1), updatedFile]);
      } catch (error) {
        message.error("Image compression failed");
      }
    } else {
      setFileList(fileList);
    }
  };

  const handlePreview = async (file) => {
    setPreviewImage(file.url || file.thumbUrl);
    setPreviewOpen(true);
  };


  return (
    <div>
      <Steps current={currentStep}>
        <Step title="Add Product" />
        <Step title="Add Color" />
        <Step title="Add Size" />
        <Step title="Add Images" />
      </Steps>
      {currentStep === 0 && (
        <>
          <div className="add-product-side-bar-main-con">
            <Form form={form} onFinish={handleProductSubmit} layout="vertical">
              <Form.Item name="product_name" label="Product Name" rules={[{ required: true, message: "Please enter product name" }]}>
                <Input placeholder="Enter product name" onChange={handleProductNameChange} />
              </Form.Item>
              <Form.Item name="product_desc" label="Product Description" rules={[{ required: true, message: "Please enter product description" }]}>
                <Input.TextArea placeholder="Enter product description" />
              </Form.Item>
              <Form.Item name="category_id" label="Category" rules={[{ required: true, message: "Please select a category" }]}>
                <Select placeholder="Select category">
                  {categories.map((category) => (
                    <Option key={category.category_Id} value={category.category_Id}>
                      {`${category.category_name} (${category.gander})`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="product_type" label="Product Type" rules={[{ required: true, message: "Please select product type" }]}>
                <Input placeholder="Enter Product Type" />
              </Form.Item>
              <Form.Item name="Material" label="Product Material" rules={[{ required: true, message: "Please select product material" }]}>
                <Input placeholder="Enter Product Material" />
              </Form.Item>
              <Form.Item name="care" label="Product care" rules={[{ required: true, message: "Please select product care" }]}>
                <Input placeholder="Enter Product care" />
              </Form.Item>
              <Form.Item name="product_code" label="Product code" rules={[{ required: true, message: "Please select product code" }]}>
                <Input placeholder="Enter Product code" />
              </Form.Item>
              <Form.Item name="Breadth" label="Box Breadth" rules={[{ required: true, message: "Please Enter Box Breadth" }]}>
                <Input placeholder="Enter Box Breadth" />
              </Form.Item>
              <Form.Item name="Height" label="Box Height" rules={[{ required: true, message: "Please Enter Box Height" }]}>
                <Input placeholder="Enter Box Height" />
              </Form.Item>
              <Form.Item name="Length" label="Box Length" rules={[{ required: true, message: "Please Enter Box Length" }]}>
                <Input placeholder="Enter Box Length" />
              </Form.Item>
              <Form.Item name="slug" label="Slug" rules={[{ required: true, message: "Please enter slug" }]}>
                <Input placeholder="Slug auto generated from product name" disabled />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>Next</Button>
              </Form.Item>
            </Form>
          </div>
        </>
      )}
      {currentStep === 1 && (
        <>
          <div className="add-product-side-bar-main-con">
            <Form form={colorForm} onFinish={handleColorSubmit} layout="vertical">
              <Form.Item name="color_code" label="Color Code" rules={[{ required: true, message: "Please enter color code" }]}>
                <Input placeholder="#FF5733" />
              </Form.Item>
              <Form.Item name="color_name" label="Color Name" rules={[{ required: true, message: "Please enter color name" }]}>
                <Input placeholder="Red" />
              </Form.Item>
              <Form.Item name="product_price" label="Price" rules={[{ required: true, message: "Please enter product price" }]}>
                <Input placeholder="49.99" />
              </Form.Item>
              <Form.Item name="product_qty" label="Quantity" rules={[{ required: true, message: "Please enter quantity" }]}>
                <Input placeholder="100" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>Submit Color</Button>
              </Form.Item>
            </Form>
          </div>
        </>
      )}
      {currentStep === 2 && (
        <>
          <div className="add-product-side-bar-main-con">
            <Button onClick={addSizeField} style={{ margin: "20px 0px" }}>
              Add Size
            </Button>
            <Form form={sizeForm} onFinish={handleSizeSubmit} layout="vertical">
              {sizes.map((size, index) => (
                <div key={size.id}>
                  <div className="row add-row">
                    <div className="col-3">
                      <Input
                        placeholder="Size"
                        value={size.product_size}
                        onChange={(e) => handleSizeChange(index, "product_size", e.target.value)}
                      />
                    </div>
                    <div className="col-3">
                      <Input
                        placeholder="Quantity"
                        value={size.product_size_quantity}
                        onChange={(e) => handleSizeChange(index, "product_size_quantity", e.target.value)}
                      />
                    </div>
                    <div className="col-3">
                      <Input
                        placeholder="Price"
                        value={size.product_size_price}
                        onChange={(e) => handleSizeChange(index, "product_size_price", e.target.value)}
                      />
                    </div>
                    <div className="col-3">
                      <Checkbox
                        checked={size.stock}
                        onChange={(e) => handleSizeChange(index, "stock", e.target.checked)}
                      >
                        In Stock
                      </Checkbox>
                    </div>
                  </div>
                </div>
              ))}
              <Button type="primary" htmlType="submit" loading={loading} style={{ marginTop: 20 }}>
                Submit Sizes
              </Button>
            </Form>
          </div>
        </>
      )}

      {currentStep === 3 && (
        <div className="add-product-side-bar-main-con">
          <Upload
            listType="picture-card"
            fileList={fileList}
            onPreview={(file) => {
              setPreviewImage(file.url || file.thumbUrl);
              setPreviewOpen(true);
            }}
            beforeUpload={() => false}
            onChange={handleChange}
            onRemove={(file) => {
              setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
            }}
          >
            {fileList.length >= 8 ? null : (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            )}
          </Upload>


          <Modal open={previewOpen} footer={null} onCancel={() => setPreviewOpen(false)}>
            <img alt="preview" style={{ width: "100%" }} src={previewImage} />
          </Modal>

          <Button type="primary" onClick={handleImageUpload} loading={loading} style={{ marginTop: 20 }}>
            Upload Images
          </Button>
        </div>
      )}
    </div>
  );
};

export default Product;
